import { render, staticRenderFns } from "./PrintTag.vue?vue&type=template&id=2c11e2e8"
import script from "./PrintTag.vue?vue&type=script&lang=js"
export * from "./PrintTag.vue?vue&type=script&lang=js"
import style0 from "./PrintTag.vue?vue&type=style&index=0&id=2c11e2e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports